import type { LifecycleOperationFence } from '../services/VerificationLifecycleService';

const operationContexts = new WeakMap<object, LifecycleOperationFence>();

export const attachVerificationOperationContext = <T extends object>(
  result: T,
  source: LifecycleOperationFence | null,
): T => {
  if (source) operationContexts.set(result, source);
  return result;
};

export const getVerificationOperationContext = (
  result: unknown,
): LifecycleOperationFence | null =>
  typeof result === 'object' && result !== null
    ? operationContexts.get(result) || null
    : null;
